import { UserName } from "../../../../Users/shared/UserName.js";
import { FormBuilderDisplayRenderer } from "../../../../FormBuilder/components/FormBuilderDisplayRenderer/index.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventPresentation/components/EventDispositionFormBuilder.tsx
function EventDispositionFormBuilder({ event }) {
	return /* @__PURE__ */ jsx("div", { children: event.assignedUsers.map(({ user, userId }) => {
		const values = event.dispositionFormInputByAssignedUserId?.[userId];
		if (!values?.formId) return null;
		if (!values || Object.keys(values).length === 0) return null;
		return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
			className: "font-bold",
			children: /* @__PURE__ */ jsx(UserName, { user })
		}), /* @__PURE__ */ jsx("div", {
			className: "flex",
			children: /* @__PURE__ */ jsx("div", {
				className: "grow",
				children: values && /* @__PURE__ */ jsx(FormBuilderDisplayRenderer, {
					formId: values.formId,
					valuesByFieldId: values.fields
				}, userId)
			})
		})] }, userId);
	}) });
}
//#endregion
export { EventDispositionFormBuilder };

//# sourceMappingURL=EventDispositionFormBuilder.js.map